import { render } from "./Identity_check.vue?vue&type=template&id=34a7c895"
import script from "./Identity_check.vue?vue&type=script&lang=js"
export * from "./Identity_check.vue?vue&type=script&lang=js"
script.render = render

export default script